
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/create",
      function () {
        return require("private-next-pages/company/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company/create"])
      });
    }
  